import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './agents-setup.css';
import _ from 'lodash';
import TimeAgo from 'react-timeago';
import copy from 'copy-to-clipboard';
import CreateAgentModal from './create-agent-modal/CreateAgentModal';
import RESTService from '../../services/RESTService';
import Spinner from '../../components/spinner/Spinner';
import InputField from '../../components/input-field/InputField';
import DialogModal from '../../components/dialog-modal/DialogModal';
import MultiToggle from '../../components/multi-toggle/MultiToggle';
import RoutingService from '../../services/RoutingService';
const connect = new RESTService();
const RS = new RoutingService();

class AgentsSetup extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			agents: [],
			toAlert: [],
			emailAlert: '',
			searchText: '',
			filterValue: 'all',
			loading: true,
			showAlerts: true,
			loadingAlerts: true,
			sortOptions: [{ value: 'all', label: 'All' }, { value: 'online', label: 'Online' }, { value: 'offline', label: 'Offline' }],
			activeModal: '',
			agentOpen: '',
			currentAgent: null
		};
	}

	componentDidMount() {
		this.loadAgents();
		this.loadAlerts();
	}

	closeDetails = () => {
		this.observe(() => {
			this.data.currentAgent = null;
			this.data.agentOpen = '';
		});
	};

	sortAgents = () => {
		this.data.agents.sort(function(a, b) {
			var c = new Date(a.registerDate);
			var d = new Date(b.registerDate);
			return d - c;
		});
	};

	loadAgents = () => {
		connect.getAgents().then(res => {
			this.observe(() => {
				this.data.agents = res.data;
				this.sortAgents();
				this.data.loading = false;
			});
		});
	};

	loadAlerts = () => {
		connect.getToAlert().then(res => {
			this.observe(() => {
				this.data.toAlert = res.data;
				this.data.loadingAlerts = false;
			});
		});
	};

	onCreateAgent = () => {
		this.setData('activeModal', 'create-agent');
	};

	onSearchChange = evt => {
		this.setData('searchText', evt.target.value);
	};

	onFilterChange = val => {
		this.setData('filterValue', val);
	};

	onCloseModal = () => {
		this.setData('activeModal', '');
	};

	onHandleCreate = () => {
		this.setData('loading', true);
		this.loadAgents();
		this.onCloseModal();
	};

	onConfirmDeleteAgent = () => {
		this.observe(() => {
			this.data.loading = true;
			this.data.activeModal = '';
		});
		let agent = _.find(this.data.agents, { _id: this.data.toDelete });
		connect.removeAgent(agent.name).then(() => {
			this.loadAgents();
		});
	};

	onConfirmDeleteAlert = () => {
		this.observe(() => {
			this.data.loadingAlerts = true;
			this.data.activeModal = '';
		});
		_.pull(this.data.toAlert, this.data.toDelete);
		connect.updateAlerts(this.data.toAlert).then(() => {
			this.loadAlerts();
		});
	};

	onDeleteAgent = evt => {
		let id = evt.target.dataset.id;
		if (id) {
			this.observe(() => {
				this.data.toDelete = id;
				this.data.activeModal = 'delete-agent';
			});
		}
	};

	onRemoveAlert = evt => {
		let email = evt.target.dataset.email;
		if (email) {
			this.observe(() => {
				this.data.toDelete = email;
				this.data.activeModal = 'delete-alert';
			});
		}
	};

	onEmailChange = evt => {
		this.setData('emailAlert', evt.target.value);
	};

	onAddAlert = () => {
		if (!this.isValidEmail(this.data.emailAlert) || this.data.toAlert.indexOf(this.data.emailAlert) >= 0) {
			return;
		}
		this.observe(() => {
			this.data.loadingAlerts = true;
			this.data.toAlert.push(this.data.emailAlert);
			connect.updateAlerts(this.data.toAlert).then(() => {
				this.loadAlerts();
			});
			this.data.emailAlert = '';
		});
	};

	isValidEmail = email => {
		const REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
		if (REGEX.test(email)) {
			for (let i = 0; i < this.data.toAlert.length; i++) {
				if (email.toLowerCase() === this.data.toAlert[i].toLowerCase()) {
					return false;
				}
			}
			return true;
		}
		return false;
	};

	loadConfig = evt => {
		let id = evt.currentTarget.dataset.agent;
		if (id) {
			let agent = _.find(this.data.agents, { _id: id });
			if (agent && !agent.configuration) {
				connect.getAgentConfig(agent.name).then(res => {
					let agents = this.data.agents;
					let newAgent = _.find(agents, { _id: id });
					if (newAgent) {
						newAgent.configuration = res.data;
						this.setData('agents', agents);
					}
				});
			}
		}
	};

	viewAgentDetails = evt => {
		let id = evt.currentTarget.dataset.agent;
		if (
			id &&
			(this.data.currentAgent && id === this.data.currentAgent._id) &&
			!evt.target.classList.contains('mdi-delete') &&
			!evt.target.classList.contains('mdi-key')
		) {
			this.closeDetails();
			return;
		}
		let classes = evt.target.classList;
		if ((id && (!classes.contains('mdi') && !classes.contains('action'))) || classes.contains('mdi-chevron-down')) {
			let agent = _.find(this.data.agents, { _id: id });
			connect.getAgentConfig(agent.name).then(res => {
				agent.configuration = res.data;
				this.setData('currentAgent', agent);
				this.observe(() => {
					this.data.currentAgent = agent;
					this.data.agentOpen = '';
				});
				setTimeout(() => {
					this.setData('agentOpen', 'open');
				}, 100);
			});
		}
	};

	buildAlertCards = () => {
		let cards = [];
		_.each(this.data.toAlert, alert => {
			cards.push(
				<div className="alert-card hbox vcenter animated fadeIn" key={_.replace(_.replace(alert, '@', ''), '.', '')}>
					<div className="who grow-1 ellipse">{alert}</div>
					<i className="mdi mdi-delete" data-rh="Remove" data-rh-at="left" data-email={alert} onClick={this.onRemoveAlert} />
				</div>
			);
		});
		if (cards.length === 0) {
			cards.push(
				<div className="empty-list animated fadeIn" key="no-alerts-key">
					No alerts have been created.
				</div>
			);
		}
		return cards;
	};

	copyKey = evt => {
		let id = evt.target.dataset.id;
		if (id) {
			let agent = _.find(this.data.agents, { _id: id });
			if (agent && agent.configuration) {
				copy(JSON.stringify(agent.configuration, null, 2));
				RS.showInfo('RSA key copied to clipboard');
			}
		}
	};

	buildAgentList = agents => {
		let items = [];
		let filter = this.data.filterValue;
		let search = this.data.searchText;
		agents = _.filter(agents, ag => {
			if (filter === 'all') {
				return true;
			}
			if (filter === 'offline' && ag.online <= 0) {
				return true;
			}
			if (filter === 'online' && ag.online > 0) {
				return true;
			}

			return false;
		});
		agents = _.filter(agents, ag => {
			if (search.length > 0 && ag.name.indexOf(search) < 0) {
				return false;
			}
			return true;
		});
		for (let i = 0; i < agents.length; i++) {
			let ag = agents[i];
			let status = ag.online > 0 ? 'online' : 'offline';
			if (status === 'offline' && !ag.lastSeen) {
				status = 'pending';
			}
			items.push([
				<div
					className="list-item hbox vcenter"
					key={'list-item-' + ag._id}
					data-agent={ag._id}
					onClick={this.viewAgentDetails}
					onMouseEnter={this.loadConfig}
				>
					<div className="status vbox vcenter hcenter">
						<div className={`indicator ${status}`} />
					</div>
					<div className="name ellipse grow-1">{ag.name}</div>
					<div className="created ellipse grow-1">
						<TimeAgo date={ag.registerDate} />
					</div>
					<div className="last-seen ellipse grow-1">{ag.lastSeen ? <TimeAgo date={ag.lastSeen} /> : <div className="na-tag">n/a</div>}</div>
					<div className="actions hbox vcenter hleft">
						<div className="action vbox hcenter vcenter" data-rh="Copy RSA Key" data-rh-at="top" data-id={ag._id} onClick={this.copyKey}>
							<i className="mdi mdi-key" data-id={ag._id} />
						</div>
						<div className="action vbox hcenter vcenter delete" data-id={ag._id} onClick={this.onDeleteAgent} data-rh="Delete Agent" data-rh-at="top">
							<i className="mdi mdi-delete" data-id={ag._id} onClick={this.onDeleteAgent} />
						</div>
						<i className={`mdi mdi-chevron-${this.data.currentAgent && ag._id === this.data.currentAgent._id ? 'up' : 'down'}`} />
					</div>
				</div>,
				this.getOpenAgent(ag)
			]);
		}
		if (items.length === 0) {
			return <div className="empty-list animated fadeIn">You have no agents.</div>;
		}
		return items;
	};

	getOpenAgent = ag => {
		if (this.data.currentAgent && this.data.currentAgent._id === ag._id) {
			let is = ag.instances;
			let items = [];
			for (let i = 0; i < is.length; i++) {
				let instance = is[i];
				let addresses = instance.ips;
				let ips = [];
				_.forEach(addresses, address => {
					ips.push(
						<div className="ip-address" key={address}>
							{address}
						</div>
					);
				});
				items.push(
					<div className="item hbox vcenter" key={'ip-key-' + instance.id}>
						<div className="spacer" />
						<div className="instance grow-2">{instance.id}</div>
						<div className="ip hbox vcenter grow-1">{ips}</div>
						<div className="actions hbox hleft">
							<i className="mdi mdi-heart-pulse" data-rh="Ping Agent" data-rh-at="left" />
						</div>
					</div>
				);
			}
			return (
				<div className={`agent-details ${this.data.agentOpen}`} key={'details-key-' + ag._id}>
					<div className="hbox vcenter">
						<div className="row hbox vcenter">
							Hostname: <div className="value">{ag.configuration.hostname}</div>
						</div>
						<div className="row hbox vcenter">
							Port: <div className="value">{ag.configuration.port}</div>
						</div>
					</div>
					{items.length > 0 && [
						<div className="detail-header hbox vcenter" key={Math.random().toString()}>
							<div className="spacer" />
							<div className="label grow-2">ID</div>
							<div className="label grow-1">IP</div>
							<div className="label actions hbox hleft">ACTIONS</div>
						</div>,
						<div className="instances" key={Math.random().toString()}>
							{items}
						</div>
					]}
				</div>
			);
		}
		return '';
	};

	toggleRightPanel = () => {
		this.setData('showAlerts', !this.data.showAlerts);
	};

	render() {
		let { searchText, filterValue, sortOptions, activeModal, agents, showAlerts, loadingAlerts, emailAlert } = this.data;
		return (
			<div className="agents-config-view hbox animated fadeIn">
				<div className="left-content grow-1">
					<div className="panel-header hbox vcenter">
						<div className="sub-title grow-1">
							The On-premise agent is a process that runs inside a secure network and establishes a Web Socket connection with the Core Services
							platform, enabling the use connectors that would otherwise be unreachable from the cloud.
							<a href="#download" className="link">
								Download Vagrant File
							</a>
						</div>
						<div className="search-ctn hbox vcenter">
							<i className="mdi mdi-magnify" />
							<input className="search-input" value={searchText} onChange={this.onSearchChange} placeholder="Search Agents..." />
						</div>
					</div>
					<div className="agent-list-panel panel animated fadeIn">
						<div className="list-header hbox vcenter">
							<div className="title grow-1">Agents List</div>
							<MultiToggle options={sortOptions} active={filterValue} onChange={this.onFilterChange} />
							<button className="btn primary square vbox hcenter vcenter" onClick={this.onCreateAgent}>
								<i className="mdi mdi-plus" />
							</button>
						</div>
						<div className="list-labels hbox vcenter">
							<div className="spacer" />
							<div className="label grow-1">Name</div>
							<div className="label grow-1">Created</div>
							<div className="label grow-1">Last Seen</div>
							<div className="label actions">Actions</div>
						</div>
						<div className="list-items">{this.buildAgentList(agents)}</div>
					</div>
				</div>
				<div className={`right-content ${showAlerts ? '' : 'collapsed'}`}>
					<div className="top-spacer" />
					<div className="alert-ctn panel animated fadeIn">
						<div className={`toggle-tab vbox hcenter vcenter ${showAlerts ? '' : 'collapsed'}`} onClick={this.toggleRightPanel}>
							<i className={`mdi mdi-chevron-${showAlerts ? 'right' : 'left'}`} />
						</div>
						<div className="header hbox vcenter">
							<div className="title grow-1">
								<i className="mdi mdi-alert" /> Alerts
							</div>
						</div>
						<div className="sub-title">This is a list of all the people that will get a notification when one of the agents is not working.</div>
						<div className="input-ctn hbox vcenter">
							<InputField
								label="Email:"
								placeholder="Enter email address to alert"
								className="grow-1"
								name="toAlert"
								type="text"
								value={emailAlert}
								handleChange={this.onEmailChange}
							/>
							<button className="btn primary" disabled={!this.isValidEmail(emailAlert)} onClick={this.onAddAlert}>
								<i className="mdi mdi-plus" />
							</button>
						</div>
						<div className="alert-list">{loadingAlerts ? <Spinner height="400px" text="Loading Alerts" /> : this.buildAlertCards()}</div>
					</div>
				</div>
				<CreateAgentModal isOpen={activeModal === 'create-agent'} onCancel={this.onCloseModal} onConfirm={this.onHandleCreate} />
				<DialogModal
					isOpen={activeModal === 'delete-agent'}
					type="warning"
					title="Are you sure?"
					text="Deleting an agent cannot be undone."
					onCancel={this.onCloseModal}
					onConfirm={this.onConfirmDeleteAgent}
					showCancelButton
				/>
				<DialogModal
					isOpen={activeModal === 'delete-alert'}
					type="warning"
					title="Are you sure?"
					text="This person will no longer receive alerts."
					onCancel={this.onCloseModal}
					onConfirm={this.onConfirmDeleteAlert}
					showCancelButton
				/>
			</div>
		);
	}
}

export default AgentsSetup;



// WEBPACK FOOTER //
// ./src/views/agents-setup/AgentsSetup.js